@if (primaryPost) {
  <rma-blog-post-preview class="primaryFeaturedBlog" [blog]="primaryPost" thumbnailSize="large" />
}

@if (featuredPosts.length > 0) {
  <div class="featuredBlogList">
    @for (blog of featuredPosts; track blog) {
      <rma-blog-post-preview class="secondaryFeaturedBlog" [blog]="blog" thumbnailSize="post-grid-2" />
    }
  </div>
}

@if (normalPosts.length > 0) {
  <div class="blogList">
    @for (post of normalPosts; track post) {
      <rma-blog-post-preview [blog]="post" thumbnailSize="medium" />
    }
  </div>
}

@if (isLoading$ | async) {
  <div class="blogList">
    @for (x of [].constructor(9); track x) {
      <rma-blog-post-skeleton />
    }
  </div>
} @else {
  <div class="showMoreButtonContainer">
    @if (showMore) {
      <button (click)="handleLoadMore()" type="button" mat-button>
        <span>Show More </span>
        <rma-icon glyph="expand_more" />
      </button>
    }
  </div>
}
